import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { claimNames } from "@auth/models/token";
import { AboutArgs } from "@layout/components/about/about-args";
import { DynamicDialogConfig } from "primeng/dynamicdialog";
import { TableModule } from "primeng/table";

interface UserDataRow {
    label: string;
    value: string;
}

@Component({
    selector: "app-about",
    templateUrl: "./about.component.html",
    styleUrl: "./about.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TableModule],
})
export class AboutComponent {
    private readonly dialogConfig = inject(DynamicDialogConfig);
    private readonly args = this.dialogConfig.data as AboutArgs;

    public aboutInfo = this.assembleAboutInfo();

    private assembleAboutInfo(): UserDataRow[] {
        const claims = this.args.claimsToDisplay.reduce((acc, curr) => {
            const rawClaimValue = this.args.token[curr];
            let claimValue: string;

            if (Array.isArray(rawClaimValue)) {
                claimValue = rawClaimValue.join(", ");
            } else {
                claimValue = rawClaimValue.toString();
            }

            acc.push({
                label: claimNames[curr],
                value: claimValue,
            });
            return acc;
        }, [] as UserDataRow[]);

        const customInfo = Object.entries(this.args.customInformation).map(([label, value]) => ({ label, value }));

        return [...customInfo, ...claims];
    }
}
